export default __webpack_public_path__ + "static/media/gallery-13-3.c193829b.webp";